import React from 'react'
import Styles from './TemplatesVideoIcon.module.scss'
import cx from 'classnames'
import { Play3 } from 'blaze-ui/icons'

type Props = {
  size?: 'sm' | 'lg'
}

export const TemplatesVideoIcon = ({ size = 'sm' }: Props): React.ReactElement => {
  return (
    <div className={cx(Styles.videoIconContainer, Styles[size])}>
      <Play3 size={size === 'sm' ? 14 : 24} />
    </div>
  )
}
